import React from "react";
import JobApplicationScheduledInterviewHeader from "./JobApplicationScheduledInterviewHeader";
import { Interview } from "../../../../Entities/Interview";
import { JobApplication } from "../../../../Entities/JobApplication";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import JobApplicationScheduledInterviewMeetingDetails from "./JobApplicationScheduledInterviewMeetingDetails";
import JobApplicationScheduledInterviewParticipants from "./JobApplicationScheduledInterviewParticipants";
import "./JobApplicationScheduledInterview.scss";

interface JobApplicationScheduledInterviewProps {
  scheduledInterview: Interview | null;
  jobApplication: JobApplication | null;
  jobPost: JobDescriptionEntity | null;
}

const JobApplicationScheduledInterview: React.FC<
  JobApplicationScheduledInterviewProps
> = ({ scheduledInterview, jobApplication, jobPost }) => {
  if (!scheduledInterview || !jobApplication || !jobPost) {
    return null;
  }

  return (
    <div className="job-application-scheduled-interview-container">
      <JobApplicationScheduledInterviewHeader
        scheduledInterview={scheduledInterview}
      />
      <div className="job-application-scheduled-interview-sections-container hide-scroll-bar">
        <JobApplicationScheduledInterviewMeetingDetails
          scheduledInterview={scheduledInterview}
        />
        <JobApplicationScheduledInterviewParticipants
          scheduledInterview={scheduledInterview}
          jobPost={jobPost}
        />
      </div>
    </div>
  );
};

export default JobApplicationScheduledInterview;
